import * as React from 'react';
import './PasswordEditPanel.scss';
import { Spinner } from 'reactstrap';
import { PasswordConfirmationField } from '../fields';
import AppButton from '../../AppButton';

export interface PasswordEditPanelProps {
    password?: string;
    isPasswordValid?: boolean;
    isEditing?: boolean;
    isSubmitting?: boolean;
    label?: string;
    confirmLabel?: string;
    placeholder: string;
    confirmPlaceholder: string;
    passwordsMustMatchText: string;
    cancelLabel: string;
    saveLabel: string;
    infoText?: string;
    infoAsText?: boolean;
    hideActions?: boolean;
    onPasswordChange: (password: string, valid: boolean) => void;
    onCancel: () => void;
    onSave: () => void;
}

const PasswordEditPanel: React.FC<PasswordEditPanelProps> = ({
    password = '',
    isPasswordValid = true,
    isEditing = false,
    isSubmitting = false,
    label,
    confirmLabel,
    placeholder,
    confirmPlaceholder,
    passwordsMustMatchText,
    cancelLabel,
    saveLabel,
    infoText,
    infoAsText = false,
    hideActions = false,
    onPasswordChange,
    onCancel,
    onSave,
}) => {
    return (
        <div className="passwordPanel">
            <PasswordConfirmationField
                id={'user-password'}
                label={label}
                confirmLabel={confirmLabel}
                placeholder={placeholder}
                confirmPlaceholder={confirmPlaceholder}
                stacked
                value={password}
                needToConfirmText={passwordsMustMatchText}
                info={infoText}
                infoAsText={infoAsText}
                onChange={onPasswordChange}
            />
            {!hideActions && (
                <div className="passwordPanelActions">
                    <AppButton
                        id={'user-password-cancel-button'}
                        onClick={onCancel}
                    >
                        {cancelLabel}
                    </AppButton>
                    <AppButton
                        id={'user-password-save-button'}
                        className="primaryActionButton"
                        disabled={isSubmitting || !isPasswordValid || !password}
                        onClick={onSave}
                    >
                        {isSubmitting && <Spinner size="sm" color="secundary"/>}
                        {saveLabel}
                    </AppButton>
                </div>
            )}
        </div>
    );
};

export default PasswordEditPanel;
